module.exports = __webpack_public_path__ + "static/img/default.6b22177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.png
// module id = Lg5A
// module chunks = 49